import React from 'react';

function AboutUs() {
  return (
    <div>
          <h2 style={{ color: "white"}}>Who We Are</h2>
      <p>
          The “Ask the Law” website for legal services and consultations is a modern electronic platform specialized in providing legal advice. It connects individuals, companies, or any natural or legal person from various Gulf countries and the Arab world with specialized lawyers. The platform aims to save time, effort, and costs, enabling users to obtain legal advice electronically without incurring travel expenses, thus speeding up the process of obtaining required legal advice and statements.
        </p>
        <p>
          The site is distinguished in all its sections, collaborating with a group of distinguished lawyers from various Arab Gulf countries and Arab countries. It provides legal consultation services and knowledge of the rule of law in various branches and sections of law. The platform arranges appointments between clients seeking advice and competent lawyers, allowing clients to obtain the required legal advice for a certain fee.
        </p>

        
     
    </div>
  );
}

export default AboutUs;
